import { css, keyframes } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { Text } from "nectar-ui";

const slideUpAnimation = keyframes`
  from {
    transform: translateY(10px);
    opacity: 0.3;
  }
  
  to {
    transform: translateY(0px);
    opacity: 1;
  }
`;

const slideDownAnimation = keyframes`
  from {
    transform: translateY(-10px);
    opacity: 0.3;
  }
  
  to {
    transform: translateY(0px);
    opacity: 1;
  }
`;

export const StatWrapper = styled.div<{ theme: NectarTheme["theme"]; clickable: boolean }>`
  ${({ theme, clickable }) => `
    display: flex;
    flex-grow: 1;
    max-width: calc(202px - 24px) !important;
    align-items: left;
    height: fit-content;
    flex-direction: column;
    box-sizing: content-box;
    transition: all 0.3s ease;
    gap: ${theme.spacings.sm};
    color: ${theme.colors.gray900};
    border-radius: ${theme.borderRadius.md};
    padding: ${theme.spacings.xs} ${theme.spacings.sm};

    ${
      clickable
        ? `
      cursor: pointer;
      &:hover {
        background-color: ${theme.colors.gray100};
      }
      label {
        cursor: pointer;
      }
    `
        : ""
    }

  `}
`;

export const ValueContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: left;
    gap: 0 ${theme.spacings.xxs};
  `}
`;

export const StatPercentageContainer = styled.div<NectarTheme & { positive: boolean }>`
  ${({ theme, positive }) => css`
    display: flex;
    align-items: baseline;
    gap: ${theme.spacings.xxs};

    & svg {
      animation: ${positive ? slideUpAnimation : slideDownAnimation} 0.8s ease-out;
    }
  `}
`;

export const StatValue = styled.p<NectarTheme & { redValue: boolean }>`
  ${({ theme, redValue }) => `
    font-size: ${theme.typography.headings.md};
    font-weight: ${theme.fontWeight.semiBold};
    ${redValue && `color: ${theme.colors.danger500};`}
  `}
`;

export const StatLabel = styled.label<NectarTheme>`
  ${({ theme }) => `
    font-size: 14px !important;
    font-weight: ${theme.fontWeight.semiBold};
    color: ${theme.colors.gray500};
    line-height: 1.4;
    display: flex;
    flex-direction: column;
    margin-bottom: 4px;
  `}
`;

export const StatComparisonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledComparisonDetailsText = styled(Text)`
  margin: 0 !important;
`;
